import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface AttendanceRecord {
  attendanceDate: string;
  attendanceLocation: string;
  attendanceCreator: string;
  attendanceOn: string;
}

@Component({
  selector: "app-attendance-history",
  templateUrl: "./attendance-history.component.html",
  styleUrls: ["./attendance-history.component.scss"],
})
export class AttendanceHistoryComponent {
  dataSource: AttendanceRecord[] = [];

  constructor(private dialogRef: MatDialogRef<AttendanceHistoryComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
